/** LocalStorage key: set when user dismisses the first-login "Coming Soon" modal. Once set, the modal is not shown again. */
export const COMING_SOON_DISMISSED_KEY = 'ignite-ops-portal-coming-soon-dismissed';

/** LocalStorage key: persists AI chat conversations between sessions. */
export const AI_CHAT_STORAGE_KEY = 'ai-chat-conversations';

/** LocalStorage key: persists the currently selected AI chat ID between sessions. */
export const AI_CHAT_SELECTED_KEY = 'ai-chat-selected-id';
